import(/* webpackMode: "eager" */ "/root/lp-frontend/node_modules/next/dist/client/script.js");
;
import(/* webpackMode: "eager" */ "/root/lp-frontend/node_modules/next/dist/shared/lib/lazy-dynamic/dynamic-bailout-to-csr.js");
;
import(/* webpackMode: "eager" */ "/root/lp-frontend/node_modules/next/dist/shared/lib/lazy-dynamic/preload-css.js");
;
import(/* webpackMode: "eager" */ "/root/lp-frontend/node_modules/next/font/local/target.css?{\"path\":\"src/app/[lang]/layout.jsx\",\"import\":\"\",\"arguments\":[{\"src\":\"../../fonts/InterVariable.woff2\",\"display\":\"swap\",\"preload\":true,\"fallback\":[\"Arial\",\"sans-serif\"]}],\"variableName\":\"inter\"}");
;
import(/* webpackMode: "eager" */ "/root/lp-frontend/node_modules/swiper/swiper.css");
;
import(/* webpackMode: "eager" */ "/root/lp-frontend/public/Mobile Banner.webp");
;
import(/* webpackMode: "eager" */ "/root/lp-frontend/public/Web banner.webp");
;
import(/* webpackMode: "eager" */ "/root/lp-frontend/src/app/[lang]/bitrixScript.jsx");
;
import(/* webpackMode: "eager" */ "/root/lp-frontend/src/app/[lang]/globals.css");
;
import(/* webpackMode: "eager", webpackExports: ["default"] */ "/root/lp-frontend/src/components/FullLayout.jsx");
;
import(/* webpackMode: "eager" */ "/root/lp-frontend/src/context/dictionaryProvider.tsx");
